import { useCallback, useMemo } from "react";
import { useTranslation } from "../hooks";
import { convertNameToId } from "../utils";
export default function useTranslatedChatSize() {
    const { t } = useTranslation();
    const translatedByChatSizeId = useMemo(() => ({
        regular: t("chatbotFilters:filterByChatSize.sizes.regular"),
        small: t("chatbotFilters:filterByChatSize.sizes.small"),
        medium: t("chatbotFilters:filterByChatSize.sizes.medium"),
        large: t("chatbotFilters:filterByChatSize.sizes.large"),
    }), [t]);
    const getTranslatedChatSize = useCallback((name) => {
        if (!name)
            return "";
        const id = convertNameToId(name);
        return (translatedByChatSizeId[id] ??
            name);
    }, [translatedByChatSizeId]);
    return { getTranslatedChatSize };
}
